import TunerComponent from '../tunerlib/TunerComponent'

export default function TunerPage(props) {
    return <TunerComponent/>
}
